const Water = () => {
  return (
    <svg viewBox='-420 0 100 100' xmlns='http://www.w3.org/2000/svg'>
      <g>
        <circle fill='#C1D7E9' cx='-370' cy='50' r='50'></circle>
        <path
          fill='#0D0F0F'
          d='M-352.512,83.719c-4.787,4.871-10.684,7.307-17.688,7.307c-7.861,0-14.098-2.69-18.711-8.073 c-4.359-5.127-6.537-11.662-6.537-19.606c0-8.543,3.717-18.286,11.15-29.224c6.064-8.969,13.199-16.83,21.402-23.58 c-1.197,5.469-1.793,9.355-1.793,11.662c0,5.299,1.664,10.467,4.996,15.508c4.102,5.98,7.219,10.426,9.357,13.328 c3.332,5.043,4.998,9.955,4.998,14.737C-345.336,72.871-347.729,78.852-352.512,83.719z M-352.641,56.357 c-1.281-2.861-2.777-4.762-4.486-5.703c0.256,0.514,0.385,1.24,0.385,2.18c0,1.795-0.512,4.357-1.539,7.689l-1.664,5.127 c0,2.99,1.492,4.486,4.484,4.486c3.16,0,4.742-2.095,4.742-6.281C-350.719,61.721-351.359,59.223-352.641,56.357z'
        ></path>
      </g>
    </svg>
  );
};

export default Water;
